<template>
    <div>
        <base-header style="background: rgb(0,205,245);
background: radial-gradient(circle, rgba(0,205,245,1) 25%, rgba(82,227,255,1) 100%);"  class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
<!--             <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header> -->
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <projects-table title="Subscribers Data" :table_data="subscribersdata" v-if="loaded"></projects-table>
                </div>
            </div>
           <!--  <div class="row mt-5">
                <div class="col">
                    <projects-table type="dark" title="Dark Table"></projects-table>
                </div>
            </div> -->
        </div>

    </div>
</template>

<script>
    import ProjectsTable from './Tables/ProjectsTable';
    import { mapGetters } from "vuex";
    import store from "@/store";

    import { GET_SUBSCRIBERS } from "@/store/actions.type";

  export default {
    name: 'tables',
    components: {
      ProjectsTable
    },
    data() {
      return {
        loaded : false
      };
    },
    

    methods: {
        // getSubscribers() {
        // this.$store.dispatch(GET_SUBSCRIBERS_TIERS)
        // .then(({ data }) => {
        //   this.loaded = true;
        //   console.log(loaded);
        //   // this.$router.push({
        //   //   name: "article",
        //   //   params: { slug: data.article.slug }
        //   // });
        // })
        // .catch(({ response }) => {
        //   this.loaded = false;
        //   console.log("ERROR");
        //   console.log(response);
        //   // this.errors = response.data.errors;
        // });;
        // }
      // initBigChart(store) {
      //   let chartData = {
      //     datasets: [
            
      //       {
      //         label: 'New',
      //         data: this.visitsdata[store]['visits'].map(a=>a.number),
      //         borderColor: "#ffce56",
      //          borderWidth: 5
      //       },
      //       {
      //         label: 'Recurring',
      //         data: this.visitsdata[store]['recurring_visits'].map(a=>a.number),
      //         borderWidth: 5,
      //         borderColor: '#36a2eb'
      //       }
      //     ],
      //     labels: this.visitsdata[store]['visits'].map(a => a._id),
      //   };
      //   this.bigLineChart.chartData = chartData;
      //   this.bigLineChart.activeIndex = store;
      // }
    },

      computed: {
        ...mapGetters(["isAuthenticated", "subscribersdata"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
    mounted() {
        Promise.all([
          store.dispatch(GET_SUBSCRIBERS)
        ]).then(() => {
            this.loaded = true;
            console.log(this.subscribersdata);
        });
        // console.log(this.loaded);
        // this.getSubscribers();
        // console.log(this.loaded);
      
      // this.loaded = false;
      // console.log(this.subscribers);
        
        // this.loaded = false;

      // console.log(data);
      
    }
  };
</script>
<style></style>
